// Module
var code = "You should now try and find a vantage point, somewhere that gives you a wider view of the city or area you're in, maybe somewhere up high?, press ‘I’m there’ when you are. ";
// Exports
module.exports = code;